import { useParams } from "react-router-dom";
import SEO from "../components/seo/SEO";
import Breadcrumbs from "../components/seo/Breadcrumbs";
import { getCategory } from "../config/categories";
import { getCalculatorsByCategory } from "../config/calculators";
import CalculatorCard from "../components/calculator/CalculatorCard";
import { Icon } from "../components/common/Icon";
import NotFound from "./NotFound";

export default function CategoryPage() {
  const { categoryId } = useParams();
  const cat = getCategory(categoryId);
  if (!cat) return <NotFound />;
  const calcs = getCalculatorsByCategory(cat.id);

  return (
    <>
      <SEO
        title={`${cat.name} Calculators Canada (2025) — MyFinancesGuru Tools`}
        description={`${cat.description} Free Canadian calculators with plain-language explanations.`}
        path={`/calculators/category/${cat.id}`}
      />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Calculators", to: "/calculators" }, { label: cat.name, to: `/calculators/category/${cat.id}` }]} />
        <div className="flex items-center gap-4">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand/10 text-brand"><Icon name={cat.icon} className="h-7 w-7" /></span>
          <div>
            <h1 className="font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl">{cat.name}</h1>
            <p className="mt-1 text-muted-foreground">{cat.description}</p>
          </div>
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {calcs.map((c) => <CalculatorCard key={c.slug} calc={c} />)}
        </div>
      </div>
    </>
  );
}
